import { useEffect, useRef } from "react";
import { gsap, motionOK } from "../hooks/useSmoothScroll";
import { useLang } from "../hooks/useLanguage";
import { Reveal } from "./Reveal";

const FundingExample = () => {
  const ref = useRef(null);
  const { t } = useLang();

  useEffect(() => {
    if (!motionOK()) return undefined;
    const ctx = gsap.context(() => {
      gsap.fromTo(
        ".funding-row",
        { opacity: 0, y: 26 },
        {
          opacity: 1,
          y: 0,
          stagger: 0.12,
          ease: "none",
          scrollTrigger: { trigger: ".funding-panel", start: "top 88%", end: "top 40%", scrub: true },
        }
      );
    }, ref);
    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={ref}
      className="bg-white text-[#202020] py-24 md:py-32"
      style={{ backgroundColor: "#FFFFFF" }}
      data-testid="funding-example-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <Reveal className="max-w-3xl">
          <p className="label-caps">{t.UI.fundingLabel}</p>
          <h2 className="mt-4 font-serif-lux font-light text-[#141414] text-[clamp(2rem,4.5vw,3.4rem)] leading-[1.08] tracking-tight">
            {t.UI.fundingTitle}
          </h2>
          <p className="mt-5 text-smoke leading-relaxed max-w-2xl">{t.UI.fundingBody}</p>
        </Reveal>

        <div
          className="funding-panel mt-14 max-w-3xl bg-white border border-[#141414] p-8 sm:p-12"
          data-testid="funding-panel"
        >
          {t.FUNDING_ROWS.map((r) => (
            <div
              key={r.label}
              className="funding-row flex items-baseline justify-between gap-6 border-b border-[#141414]/15 py-5"
            >
              <span className="text-[0.7rem] uppercase tracking-[0.22em] text-smoke">{r.label}</span>
              <span className="font-serif-lux text-xl sm:text-2xl font-light text-[#141414]">{r.value}</span>
            </div>
          ))}
          <div className="funding-row flex items-baseline justify-between gap-6 pt-8">
            <span className="text-[0.7rem] uppercase tracking-[0.22em] text-[#141414] font-semibold">
              {t.UI.fundingNet}
            </span>
            <span
              className="font-serif-lux text-4xl sm:text-5xl font-light text-[#141414]"
              data-testid="funding-net-figure"
            >
              {t.UI.fundingNetValue}
            </span>
          </div>
          <p className="mt-8 text-xs text-smoke leading-relaxed">{t.UI.fundingFootnote}</p>
        </div>
      </div>
    </section>
  );
};

export default FundingExample;
